module.exports = __webpack_public_path__ + "static/media/default version.4834aef4.svg";